<script setup>
import { watch } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useOnVisible } from '../composables/useOnVisible';

const store = useStore();
const { target, visible } = useOnVisible();

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agents = useMapGetter('agents/getAgents');

const fetchData = () => store.dispatch('fetchAgentConversationMetric');

watch(
  visible,
  isVisible => {
    if (!isVisible) return;
    store.dispatch('agents/get');
    fetchData();
  },
  { immediate: true }
);
</script>

<template>
  <div ref="target" class="flex flex-row flex-wrap max-w-full">
    <MetricCard
      :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')"
      :live="false"
    >
      <AgentTable
        :agents="agents"
        :agent-metrics="agentConversationMetric"
        :is-loading="uiFlags.isFetchingAgentConversationMetric"
      />
    </MetricCard>
  </div>
</template>
